import { UserService } from 'src/app/common/services/user.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription, distinctUntilChanged, tap } from 'rxjs';

import { ReportService } from '../../services/report.service';
import { ReportsViewEnum } from '../../models/enums/reports.enum';
import { SharedService } from 'src/app/common/services/shared.service';
import { MatDialog } from '@angular/material/dialog';
import { SaveReportDailogComponent } from '../save-report-dailog/save-report-dailog.component';
import { actionIdConstants } from 'src/app/common/constants/common.contants';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from 'src/app/common/services/store.service';
import { ReportMapService } from '../../services/report-map.service';
import { ReportTransactionService } from '../reports-lists/components/report-transactions/report-transactions.service';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { ApiService } from 'src/app/common/services/api.service';
import moment from 'moment';
import { activityPayload } from 'src/app/common/models/userActivity.model';

@Component({
  selector: 'app-report-data',
  templateUrl: './report-data.component.html',
  styleUrls: ['./report-data.component.css']
})
export class ReportDataComponent implements OnInit, OnDestroy {

  currentReportView: number = ReportsViewEnum.mapView;
  viewType = ReportsViewEnum;
  currentReportView$: Subscription = new Subscription();
  currentToggle$: Subscription = new Subscription();
  routeSub$: Subscription = new Subscription();
  languageSub$: Subscription = new Subscription();
  currentToggle: boolean = false;
  currentReportID: number | null = null;
  queryParams: any;
  currentReportData: any;
  filter_list: any = [];
  currentLang: string = '';
  startTime = new Date();
  reportId: any;
  saveReporList: any = [];
  is_saved: boolean = false;
  sr_id!: any;
  isReport: boolean = false;
  selectReportSub$: Subscription = new Subscription();
  placeCode: string = '';
  studyName: string = '';
  reportName: string = '';
  componentName: string = '';
  user_info!: any;
  is_save_allow:boolean=false;
  downloadLoader: boolean =false;
  projectReportView: boolean =false;
  showTentantMap: any =false;
  isDetailPage: boolean = false;
  constructor(
    public reportService: ReportService,
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
    private matDailog: MatDialog,
    private userService: UserService,
    private router: Router,
    public translate: TranslateService,
    private storeService: StoreService,
    private mapService: ReportMapService,
    private reportTransactionService: ReportTransactionService,
    private alertService: AlertService,
    private apiServive: ApiService
  ) { }

  ngOnInit() {
let ignoreInit = true;
    this.user_info = this.sharedService.getUserInfo();
    
    this.reportService.projectReportView = false;
    this.projectReportView = false;
    this.getReportView();
    this.toggleReport();
    this.setLang();
    this.setReportQueryParams();
    this.getSaveReportData();
    this.selectReportSub$ = this.reportService.selectedReport$.subscribe(isReport => {
      this.isReport = isReport.flag;
      this.studyName = this.reportService?.selectedStudies?.study_name;
      this.reportName = this.reportService?.selectedRepored?.report_name;
      this.componentName = this.reportService?.getCurrentReport()?.query?.component[0];
      this.showTentantMap = false;
    })
    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    this.reportService.showTenantMap$.subscribe((data) => this.showTentantMap = data);
    this.reportService.detailPageState$.subscribe((state) => {
      this.isDetailPage = ignoreInit ? false :this.reportService.isProjectDetailOpen() || state;
    });
    ignoreInit=false;
  }

  async setReportQueryParams() {
    let x = await this.getUserSubscription();
    this.routeSub$ = this.activatedRoute.queryParams.pipe(
      distinctUntilChanged(),
    ).subscribe((params) => {
      this.reportId = this.activatedRoute.snapshot.queryParams['rid'];
      this.userService.sessionCheck();
      this.reportService.projectReportView = false;
      this.storeService.add(GlobalContants.StoreKey.latestReportRoute, this.router.url);
      this.queryParams = { ...params };
      if (params['srid']) {
        this.sr_id = params['srid'];
        this.check_saved_report();
      } else {
        this.sr_id = null;
        this.is_saved = false;
      }
      if (params['rid'] && Number(params['rid']) !== this.currentReportID) {
        this.currentReportID = Number(params['rid']);
        this.reportService.queryParams = { ...this.queryParams };
        this.currentReportData = null;
        this.reportService.filterQueryParams = this.reportService.setfilterQueryParams(this.queryParams);
        this.getReportInfo();
        this.logActivty();// only time
      } else if (params['rid'] && Number(params['rid']) === this.currentReportID) {

        this.reportService.selectedReport$.next({flag: true});
        this.reportService.queryParams = { ...this.queryParams };
        this.reportService.filterQueryParams = this.reportService.setfilterQueryParams(this.queryParams);
      } else {
        this.reportService.selectedReport$.next({flag: false});
        this.reportService.queryParams = null;
        this.reportService.filterQueryParams = null;
        this.reportService.reportView$.next(ReportsViewEnum.mapView);
      }
      
    });

  }

  setLang(): void {
    this.languageSub$ = this.sharedService.language$.subscribe(lang => {
      this.currentLang = lang;
    });
  }


  getReportInfo() {
    this.reportService.getReportData(this.queryParams).subscribe({
      next: (res: any) => {
        if (res && res.status == 200) {
          let legend = res.data[0].legend;
          this.currentReportData = {...res.data[0]};
          const currentReportData = res.data[0];
          this.currentReportData['legend'] = legend;
          this.reportService.setCurrentReport(currentReportData);
          this.reportService.setReportData.set(this.currentReportData);

          res.data[0].filter?.forEach((item:any)=>{
            if(item.parameter_name == "neigh_name"){
              let neighlist = this.sharedService.getStoreValue(GlobalContants.StoreKey.neighList)
              item.value?.forEach((itemX:any) => {
                const match = neighlist?.find((itemY:any) => (itemY.neigh_name[1]).toLowerCase() == (itemX.label[1]).toLowerCase());
                itemX.label['2'] = match ? match.neigh_name[2]: '';
              });
            }
          })
          
          this.setReportData(res); // This function use for showing selected data in breadcum
          this.is_save_allow = this.currentReportData.is_save;
          let subsreport = this.currentReportData.active;
          this.reportService.setLockReport((subsreport ? false : true));
          if(!subsreport && !this.currentReportData.is_open_for_demo){
            this.router.navigate([])
          }
          setTimeout(() => {
            this.reportService.selectedReport$.next({flag: true, type:'new_report'});
          }, 0);
          this.setFilter();
        } else {
          this.currentReportData = null;
          this.reportService.setCurrentReport(null);
        }
      },
      error: (error: any) => {
        this.currentReportData = null;
        this.reportService.setCurrentReport(null);
      }
    })
  }

  getUserSubscription(){
    return new Promise((resolve, reject) => {
      this.reportService.getUserSubscription().subscribe(
        {next:(res: any) => {
          if (res && res.status == 200) {
            this.reportService.userSubscription = res.data[0]?.access_details;
            this.reportService.userSublength = res.data.length;
            resolve(1)
          } else {
            this.reportService.userSublength = 0;
            this.reportService.userSubscription = [];
            resolve(1)
          }
        },
        error: (error:any) => {
          this.reportService.userSublength = 0;
          this.reportService.userSubscription = [];
          resolve(1)
        }}
      )
    })

   }

  /**
   * This function use for showing selected data in breadcum
   * @param res
   */
  setReportData(res: any){
    let s = {...this.reportService.selectedStudies}
    s['study_label'] = res.groupDetail.label;
    this.reportService.selectedStudies = s;
    let r = {...this.reportService.selectedRepored}
    r['report_label'] = this.currentReportData.label;
    this.reportService.selectedRepored = r;
  }

  getReportView() {
    this.currentReportView$ = this.reportService.reportView$.subscribe((view: number) => {
      this.projectReportView = this.reportService.projectReportView;
      this.currentReportView = view;
    });
  }

  toggleReport() {
    this.currentToggle$ = this.reportService.reportQueryToggle$.subscribe((toggle: boolean) => {
      this.currentToggle = toggle;
    });
  }

  toggleReportSide(toggle: boolean) {
    this.reportService.reportQueryToggle$.next(toggle);
  }

  getSaveReportData() {
    this.userService.getUserSavedReport(this.sharedService.UserId).subscribe({
      next: (res: any) => {
        if (res.status == 200) {
          this.saveReporList = res.data;
          this.check_saved_report();
        }
      },
      error: (err) => {

      }
    })
  }
  setFilter() {
    if (this.currentReportData?.filter) {
      this.filter_list = this.currentReportData?.filter;

      this.getFilterData();
      // this.getCombineFilterData('');
      this.reportService.reportFilter = this.filter_list;
    }
  }

  getFilterData() {
    this.filter_list.map((data: any) => {
       if (
        data &&
        data.value_type &&
        data.value_type == 'function' &&
        data.type != 'range' &&
        data.type != 'hidden' &&
        data.type != 'form'
      ) {
        this.reportService
          .getfilterData(data.col_name, data.table, this.queryParams)
          .subscribe((ele) => {
            let temp: any = [];
            if (ele && ele?.data) {
              ele?.data.map((val: any) => {
                if(val.filter_name){
                  temp.push({
                    val: val.filter_name,
                    label: val.filter_label,
                  });
                }
              });
            }
            data['value_list'] = temp;
          });
      } else {
        if (data.type == 'text') {
          data['textval'] = data && data.value ? data.value : '';
        } else {
          if (data && data.value && Array.isArray(data.value)) {
            data['value_list'] = data.value;
          } else {
            data['value_list'] = [];
          }
        }
      }
    });
  }
  /**
   * getCombineFilterData get filter combined data
   * @param search_text serach text
   */
 getCombineFilterData(search_text:'') {
    let filterItem:any = {
      combine_data:[]
    }
    this.filter_list.map((data: any) => {
      data['title'] = data.label;
      if (data && data.value_type && data.value_type == 'function' &&
        data.type != 'range' &&
        data.type != 'hidden') {
        filterItem['combine_data'].push({ param: data.col_name, type: data.table, search_text:''});
      } else {
          if (data.type == 'text') {
            data['textval'] = data && data.value ? data.value : '';
          } else {
            if (data && data.value && Array.isArray(data.value)) {
              data['value_list'] = data.value;
            } else {
              data['value_list'] = [];
            }
          }
        }
    });
    this.reportService.getCombinefilterData(filterItem, this.queryParams).subscribe((ele:any) => {
        let temp: any = [];
        ele?.data.map((val: any) => {
          let itemname = Object.keys(val)[0];
          if (val[itemname] != null) {
            val[itemname].map((ditem:any)=> {
            temp.push({
              val: ditem?.filter_name,
              label: ditem?.filter_label,
            });
          })
        }
        this.filter_list.find((item:any) => item.col_name == itemname)['value_list'] = temp;
      });
    });
  }

  openDailog(type: string) {

    if (type == 'save') {
      let subscription = this.reportService.userSubscription.find((sub: any) => sub.report_id === this.currentReportData?.id);
      if (!subscription?.allow_save) {
        this.alertService.warn(this.translate.instant('reports.disableDownloadAccessMsg'));
        return;
      }
      let position = {};
      if (this.currentLang == 'ar') {
        position = {
          left: `${70}px`,
          bottom: `${100}px`,
        }
      } else {
        position = {
          right: `${70}px`,
          bottom: `${100}px`,
        }
      }
      this.matDailog.open(SaveReportDailogComponent, {
        width: '399px',
        height: 'auto',
        position: position,
        data: { currentReportData: this.currentReportData, saved_report: this.saveReporList }
      }).afterClosed().subscribe(res => {
        if (res) {
          this.getSaveReportData()
        }
      })
    }
  }
  /**
   * @description activity log call
   */
  logActivty(): void {
    const endTime = new Date(); 
    this.queryParams['polygon'];
    if(this.queryParams['polygon']){
      this.queryParams['polygon'] = JSON.parse(this.queryParams['polygon'])
    }
    const activity:activityPayload = {
      entityId: this.reportId,
      actionId: actionIdConstants.View_Report,
      userdata: this.queryParams,
      entity: 'report',
    };
    this.userService.logUserActivity(activity);
  }


  /**
   * @description check the save report list
   */
  check_saved_report() {
    if (this.saveReporList) {
      let data: any = {};
      for (let key in this.queryParams) {
        if (key != 'srid') {
          data[key] = this.queryParams[key];
        }
      }
      if (this.queryParams?.srid) {
        this.sr_id = this.queryParams['srid'];
      }
      let saved = this.saveReporList.find((ele: any) => ele.id == this.sr_id);

      if (saved) {
        if (this.sharedService.compareObject(saved.data, data)) {
          this.is_saved = true;
          if (saved.filter_data) {
            this.reportService.user_preference['report_data'] = saved.filter_data;
          }
        } else {
          this.is_saved = false;
        }
      } else {
        this.is_saved = false;
      }
    }
  }

  /**
   * Reset filter
   */
  resetFilter() {
    if (this.currentReportData?.filter) {
      let queryParams = {
        oid: this.queryParams['oid'],
        gid: this.queryParams['gid'],
        rid: this.queryParams['rid'],
        polygon: this.queryParams['polygon']
      };
      // delete this.queryParams['polygon'];
      let subsReport = this.reportService.userSubscription.find((e:any)=> e.report_id == this.currentReportData.id)
      if(subsReport) this.currentReportData['filter'] = subsReport?.filter;

      let defaultValue = this.reportService.setDefaultFilter(this.currentReportData);
        // code executed when date range filter is present in report (ttm)
        // this.reportService.reportFilter.forEach((filter: any) => {
        //   if (filter?.type === 'date_range') {
        //     const today = new Date();
        //     let eDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
        //     const minDate = new Date(today);
        //     minDate.setFullYear(minDate.getFullYear() - 1);
        //     minDate.setDate(minDate.getDate() + 1);
        //     let sDate = `${minDate.getFullYear()}-${String(minDate.getMonth() + 1).padStart(2, "0")}-${String(minDate.getDate()).padStart(2, "0")}`;
        //     let finalDate = `${sDate}to${eDate},${false}`;
        //     this.reportService.ttmToggleVariable.set(false);
        //     this.reportService.ttmToggleState.set(false);
        //     if (defaultValue && !('transaction_date' in defaultValue)) {
        //       defaultValue['transaction_date'] = finalDate;
        //     }
        //   }
        // });
        //--------------------------------
      queryParams = { ...queryParams, ...defaultValue };
      this.reportService.selectedReport$.next({flag: true});
      this.mapService.reportFiltertoggle.next('reset'); //// for when filter is being applied
      // this.mapService.drawPolyToggle.next(false);
      this.router.navigate(
        [`${this.sharedService.CityLang}/reports`],
        { queryParams: queryParams }
      );
      // this.savefilterValue(queryParams);
    }
  }

  savefilterValue(value: any) {
    let filterValue = { ...value };

    if (filterValue['property_category']) {
      delete filterValue['property_category'];
    }
    if (filterValue['zoning_default']) {
      delete filterValue['zoning_default'];
    }
    if (filterValue['unit_category']) {
      delete filterValue['unit_category'];
    }
    if (filterValue['quarter']) {
      let quarter = JSON.parse(filterValue['quarter'])
      filterValue['quarter'] = quarter;
    }
    Object.keys(filterValue).forEach(value => {
      if (Array.isArray(filterValue[value])) {
        filterValue[value] = filterValue[value].join(',');
      }
    })
    delete filterValue['srid'];
    // let body = {
    //   report_id: this.reportId,
    //   user_id: this.user_info.user_id,
    //   filter_data: filterValue,
    //   added_by: this.user_info.user_id
    // }
    this.mapService.reportFilter.next(filterValue);
    // this.reportService.setUserPreference(body).subscribe((res: any) => { });
  }

  downloadInvestmentReport(module_name: string) {
    if(this.reportName === 'rental'){
      module_name = 'retail_rental'
    }else if(this.reportName === 'office_rental'){
      module_name = 'office_rental_overall'
    }
    if(!this.currentReportData?.is_download) {
      this.alertService.warn(this.translate.instant('reports.disableDownloadAccessMsg'));
      return;
    }else {
      let subscription = this.reportService.userSubscription.find((sub: any) => sub.report_id === this.currentReportData?.id);
      if (!subscription?.allow_download) {
        this.alertService.warn(this.translate.instant('reports.disableDownloadAccessMsg'));
        return;
      }
    }
    if(this.queryParams?.year){
      if(this.queryParams?.year.split(',').length > 1){
        this.alertService.warn(this.translate.instant('reports.please_select_one_year_only'));
        return;
      }
    }
    this.alertService.success(this.translate.instant('reports.preparing_your_download'));
    // this.downloadLoader=true;
    this.reportService.getReportDownload(this.queryParams, module_name).subscribe(
      {
        next: (res: any) => {
          // this.downloadLoader=false;
          if (res.status === 200) {
            if(this.reportName === 'office_rental'){
              module_name = 'office_rental'
            }
            const downloadUrl = `${this.reportTransactionService.downloadExcelUrl()}?file_name=${res.data}&city_code=${this.placeCode.toLowerCase()}&module_name=${module_name}`;
            this.sharedService.downloadExcelUrl(downloadUrl);
            this.alertService.success(this.translate.instant('reports.downloadRequestSubmitted'));
          }else{
            this.alertService.error(res?.message);
          }
        },error : ()=>{
          // this.downloadLoader=false;
        }
      })
  }

  ngOnDestroy(): void {
    this.currentReportView$?.unsubscribe();
    this.currentToggle$?.unsubscribe();
    this.routeSub$?.unsubscribe();
    this.languageSub$?.unsubscribe();
    this.currentReportData = null;
    this.currentReportID = null;
  }
}
